module.exports = __webpack_public_path__ + "static/media/page-first.6ea4c9bc.svg";